<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/home/blackList' }"
          >自有账户</el-breadcrumb-item
        >
        <el-breadcrumb-item>新增</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <div class="panel panel-default" style="">
      <div class="panel-heading">新增</div>
    </div> -->
    <el-card shadow="never">
      <div slot="header" class="box-card">
        <span>新增</span>
      </div>
      <div class="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form
              ref="form"
              :model="form"
              label-width="200px"
              :rules="rules"
            >
              <el-form-item label="商户ID" prop="id">
                <el-input v-model="form.applicationUserId"></el-input>
              </el-form-item>
              <el-form-item label="账户或角色" prop="name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="选择类型" prop="paidBlacklistType">
                <el-select v-model="form.paidBlacklistType">
                  <el-option :value="1" label="支付宝黑名单"> </el-option>
                  <el-option :value="2" label="角色名黑名单"> </el-option>
                  <el-option :value="3" label="永久名黑名单"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="remarks">
                <el-input v-model="form.remarks"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('form')"
                  >立即创建</el-button
                >
                <el-button @click="resetForm('form')">取消</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      form: {
        id: 0,
        applicationUserId: 0,
        name: '',
        paidBlacklistType: 1,
        remarks: ''
      },
      rules: {
        id: [
          {
            required: true,
            message: '请输入商户ID',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入账户或角色',
            trigger: 'blur'
          }
        ],
        paidBlacklistType: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }
        ],
        remarks: [
          {
            required: true,
            message: '请输入备注',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async save() {
      let header = await mgr();
      this.form.applicationUserId = Number(this.form.applicationUserId);
      api
        .post('/api/Paid/AddPaidBlacklist', this.form, {
          headers: {
            Authorization: 'Bearer ' + header
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    }
  }
};
</script>

<style scoped></style>
